import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import PersonIcon from "@material-ui/icons/Person";
import AddIcon from "@material-ui/icons/Add";
import Typography from "@material-ui/core/Typography";
import { blue } from "@material-ui/core/colors";
import { deepOrange, deepPurple } from "@material-ui/core/colors";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

const useStyles = makeStyles((theme) => ({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[800],
  },
  purple: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
  },
}));

export default function TileSetting(props) {
  const classes = useStyles();
  const { onClose, selectedValue, open, index, data } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        Vị trí {index + 1} - Chọn cách hiển thị
      </DialogTitle>
      <List>
        <ListItem autoFocus button onClick={() => handleListItemClick("auto")}>
          <ListItemAvatar>
            <Avatar className={classes.purple}>A</Avatar>
          </ListItemAvatar>
          <ListItemText primary="Tự động" />
          {data && data.type === "auto" && (
            <ListItemSecondaryAction>
              <CheckCircleOutlineIcon color="primary"/>
            </ListItemSecondaryAction>
          )}
        </ListItem>

        <ListItem
          autoFocus
          button
          onClick={() => handleListItemClick("manual")}
        >
          <ListItemAvatar>
            <Avatar className={classes.orange}>M</Avatar>
          </ListItemAvatar>
          <ListItemText primary="Cố định" />
          {data && data.type === "manual" && (
            <ListItemSecondaryAction>
              <CheckCircleOutlineIcon color="primary" />
            </ListItemSecondaryAction>
          )}
        </ListItem>
      </List>
    </Dialog>
  );
}

TileSetting.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
